import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import GenericModal from '../buttons/genericModal';
import EnhancedFDICDisclosure from '../bankAccount/disclosures/enhancedFDIC';

function BankCustomerBanner(props) {
	const [isBankingCustomer, setIsBankingCustomer] = useState(false);
	const [visible, setVisible] = useState(false);
	const [divStyle, setDivStyle] = useState({});

	useEffect(() => {
		localStorage.getItem("isBankingCustomer") === "true" ? setIsBankingCustomer(true) : setIsBankingCustomer(false);
	}, []);

	useEffect(() => {
		setDivStyle({
			padding: props.padding || 0,
			paddingBottom: props.paddingBottom || 0,
			margin: props.margin || ""
		})
	}, [props.padding, props.paddingBottom, props.margin]);

	return (
		<>
			{isBankingCustomer && (
				<div style={divStyle}>
					<Alert
						message={
							<span>
								Enhanced FDIC on Arpari accounts live! {' '}
								<GenericModal
									button={<span>Read more here <ArrowRightOutlined /></span>}
									showModal={() => setVisible(true)}
									modalTitle="FDIC Insurance Information"
									visible={visible}
									handleCancelModal={() => setVisible(false)}
									modalBody={
										<p>
											<EnhancedFDICDisclosure />
										</p>
									}
									size="md"
								/>
							</span>
						}
						type="info"
						banner
					/>
				</div>
			)}
		</>
	);
}

export default BankCustomerBanner;
